import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { sentimentTrackerOnboardingActions } from "stores/SentimentTracker/sentimentTrackerOnboarding/sentimentTrackerOnboardingAction";

const mapStateToProps = (state) => {
    const basePrice=window.location.href.includes('bnrathi')?'1,000':'1,999'
   
    return {
        currentStage: state.sentimentTracker.sentimentTrackerOnboarding.currentStage,
        isOnboardingDataFetched: state.sentimentTracker.isInitialFetched,
        isOnboardingDataLoading: state.sentimentTracker.sentimentTrackerOnboarding.loading.onboardingData,
        name: state.customer.loginProfile.name,
        isPaymentCompleted: state.sentimentTracker.sentimentTrackerOnboarding.isPaymentCompleted,


        overviewList: [
            { id: 1, stageNumber: 1, isOpen: false, name: 'Payment ', toolTipText: `To start receiving our buy and sell call recommendations, simply pay Rs. ${basePrice} and start receiving our buy and sell recommendations.` },
            { id: 2, stageNumber: 2, isOpen: false, name: 'CKYC', toolTipText: ' An initiative by the Indian government to set up a system that will help you perform your KYC just once before interacting with different companies in the financial industry, like us.' },
        ]
    };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    getOnboardingDataAction: sentimentTrackerOnboardingActions.getOnboardingData,
}, dispatch);

const SentimentTrackerOnboardingOverviewStore = (Container) =>
    connect(mapStateToProps, mapDispatchToProps)(Container);
export default SentimentTrackerOnboardingOverviewStore;
